"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Divider: function() {
        return _Divider.Divider;
    },
    dividerClassNames: function() {
        return _Divider.dividerClassNames;
    },
    renderDivider_unstable: function() {
        return _Divider.renderDivider_unstable;
    },
    useDividerStyles_unstable: function() {
        return _Divider.useDividerStyles_unstable;
    },
    useDivider_unstable: function() {
        return _Divider.useDivider_unstable;
    }
});
const _Divider = require("./Divider");
 // Experimental APIs - will be uncommented in the experimental release branch
 // export { useDividerBase_unstable } from './Divider';
 // export type { DividerBaseProps, DividerBaseState } from './Divider';
